import { FaEnvelope, FaSms, FaWhatsapp } from "react-icons/fa";
import { RiMessage2Line } from "react-icons/ri";

export const channelOptions = [
  { label: 'WhatsApp', value: 'whatsapp', icon: <FaWhatsapp className='text-green-500' /> },
  { label: 'SMS', value: 'sms', icon: <FaSms className='text-green-500' /> },
  { label: 'Email', value: 'email', icon: <FaEnvelope className='text-green-500' /> },
  { label: 'RCS', value: 'rcs', icon: <RiMessage2Line className='text-blue-500' /> },
];